import React, { useEffect, useState } from 'react';
import Table from "../../components/table";


function RejectedTab(props:any) {

  
  const [data, setData] = useState<any>()
  const [total, setTotal] = useState<number>();

  useEffect(() => {
    if (props.data) {
      const newValue = props.data && props.data.map((valueItem: any) => {
        valueItem.availabilityValue = {
          availability: valueItem.availability && valueItem.availability,
          availability_date: valueItem.availability_date && valueItem.availability_date,
          availability_lastUpdatedDate: valueItem.availability_lastUpdatedDate && valueItem.availability_lastUpdatedDate,
          availability_week: valueItem.availability_week && valueItem.availability_week
        }
        return valueItem
      })
      setData(newValue)
      setTotal(props.total);

    }
  
  
  }, [props])

  return (
    <div className='breakTableTh'>
      <Table  setSort={props.setSort} applySort={props.applySort} getTablesValues={props.getTablesValues} pageSize={''} data={data} rowClick={''} total={total} pageChange={''} type={'resources'}/>
    </div>
  )
}

export default RejectedTab